import React from 'react';
import { WithinContentContext } from '../../utilities/within-content-context.js';
import { ShadowBevel } from '../ShadowBevel/ShadowBevel.js';
import { Box } from '../Box/Box.js';

const Card = ({
  children,
  background = 'bg-surface',
  padding = {
    xs: '400'
  }
}) => {
  // slj: `roundedAbove` was a JS breakpoint read, which forced every Card to
  // render radius '0' on the server and correct to '300' after hydration — a
  // visible flip on every page load. Our surfaces are never edge-to-edge, so
  // the radius is unconditional. See vendor/VENDORED.md §Local modifications.
  const defaultBorderRadius = '300';
  return /*#__PURE__*/React.createElement(WithinContentContext.Provider, {
    value: true
  }, /*#__PURE__*/React.createElement(ShadowBevel, {
    boxShadow: "100",
    borderRadius: defaultBorderRadius,
    zIndex: "32"
  }, /*#__PURE__*/React.createElement(Box, {
    background: background,
    padding: padding,
    overflowX: "clip",
    overflowY: "clip",
    minHeight: "100%"
  }, children)));
};

export { Card };
